export function buscarPorCodigo<T = any>(items: any[], codigo: string): T | undefined {
  return items.find(item => item.codigo === codigo);
}
